<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#cdd5df' }">
            <v-container v-if="userIsOrganisation === false" class="contain-width">
              <v-row>
                <v-col md="4">
                  <h1 class="text-h5 black--text ml-3 font-weight-bold">{{ $t('Dashboard for') }} <span v-if="user">{{ user.name }}</span></h1>
                  <h2 class="text-subtitle-1 black--text ml-3"><span class="font-weight-bold">{{ $t('Membership number') }}</span>: <span v-if="user">{{ user.membership_number }}</span></h2>
                  <h2 class="text-subtitle-1 black--text ml-3"><span class="font-weight-bold">{{ $t('Member since') }}</span>: <span v-if="user">{{ user.created_at }}</span></h2>
                </v-col>
                <v-col md="2">
                  <div>
                    <p class="text-subtitle-1 black--text">{{ $t('Account Strength') }}</p>
                    <v-progress-linear
                        v-model="strength"
                        color="success"
                        height="25"
                        class="mb-6"
                        light
                    >
                      <template v-slot:default="{ value }">
                        <strong>{{ Math.ceil(value) }}%</strong>
                      </template>
                    </v-progress-linear>
                  </div>
                </v-col>
                <v-col md="6">
                  <v-stepper light non-linear elevation="0" flat tile alt-labels style="background-color: transparent; box-shadow: none">
                    <v-stepper-header>
                      <v-stepper-step
                          :rules="[() => stripeSubscription !== null]"
                          :complete="user && user.stripe_subscription !== null"
                          color="success"
                          step="1"
                      >
                        {{ $t('Add subscription') }}
                      </v-stepper-step>

                      <v-divider></v-divider>

                      <v-stepper-step
                          :complete="familyComplete"
                          color="success"
                          step="2"
                      >
                        {{ $t('Add family') }}
                      </v-stepper-step>

                      <v-divider></v-divider>

                      <v-stepper-step
                          :complete="tagsComplete"
                          color="success"
                          step="3"
                      >
                        {{ $t('Active tags') }}
                      </v-stepper-step>
                    </v-stepper-header>
                  </v-stepper>
                </v-col>
              </v-row>
                <v-row>
                    <v-col
                            md="4"
                            sm="12"
                    >
                        <v-card elevation="0" style="border-radius: 10px !important;">
                            <v-card-title class="flex justify-space-between">
                              <div class="primary--text">{{ $t('headings.Registered details') }}</div>
                              <v-dialog v-model="accountDialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <v-btn color="primary" icon v-on="on"><v-icon dark>mdi-pencil</v-icon></v-btn>
                                </template>
                                <v-card
                                    class="mx-auto form-card"
                                    outlined
                                >
                                  <v-card-title>
                                    <span class="headline primary--text">{{ $t('headings.Edit registered details') }}</span>
                                  </v-card-title>
                                  <v-card-text class="text--primary">
                                    <v-form v-if="user" v-model="userValid" @submit.prevent="handleSubmit">
                                      <ValidationObserver ref="userObserver">
                                        <ValidationProvider vid="name" :name="$t('labels.Name')" rules="required" v-slot="{ errors }">
                                          <v-text-field
                                              v-model="user.name"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Name')"
                                              required
                                          ></v-text-field>
                                        </ValidationProvider>
                                        <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required|email" v-slot="{ errors }">
                                          <v-text-field
                                              v-model="user.email"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Email')"
                                              required
                                          ></v-text-field>
                                        </ValidationProvider>

                                        <div class="d-flex align-start">
                                          <div style="width: 80px">
                                            <v-autocomplete
                                                class="mr-2"
                                                ref="areaCode"
                                                v-model="area"
                                                :items="countryCodes"
                                                item-text="name"
                                                item-value="code"
                                            >
                                              <template v-slot:selection="data">
                                                <span class="select-flag"><gb-flag :code="data.item.lang" size="mini" /></span>
                                              </template>
                                              <template v-slot:item="{ item }">
                                                <span class="select-flag"><gb-flag :code="item.lang" size="mini" /><span class="ml-3">{{ item.name }}</span></span>
                                              </template>
                                            </v-autocomplete>
                                          </div>
                                          <div style="width: 100%">
                                            <ValidationProvider vid="mobile" :name="$t('labels.Mobile')" :rules="{ required: true, regex: /^[+][0-9]+$/ }" v-slot="{ errors }">
                                              <v-text-field
                                                  v-model="user.mobile"
                                                  :error-messages="errors[0]"
                                                  :label="$t('labels.Mobile number (digits only)')"
                                                  required
                                                  persistent-hint
                                                  :placeholder="mobilePlaceholder"
                                                  :hint="$t('labels.Required for SMS notifications')"
                                                  @input="updateArea(user.mobile)"
                                              >
                                              </v-text-field>
                                            </ValidationProvider>
                                          </div>
                                        </div>

                                        <div v-if="userIsOrganisation === false">
                                          <h2 class="mt-6 mb-3 heading-5">{{ $t('headings.Additional notification emails') }}</h2>
                                          <ValidationProvider vid="email1" :name="$t('labels.Additional email 1')" rules="email" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="user.email1"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Additional email 1')"
                                                required
                                            ></v-text-field>
                                          </ValidationProvider>

                                          <ValidationProvider vid="email2" :name="$t('labels.Additional email 2')" rules="email" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="user.email2"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Additional email 2')"
                                                required
                                            ></v-text-field>
                                          </ValidationProvider>

                                          <h2 class="mt-6 mb-3 heading-5">Delivery address</h2>
                                          <ValidationProvider vid="address1" :name="$t('labels.Address line 1')" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="user.address1"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Address line 1')"
                                                required
                                            ></v-text-field>
                                          </ValidationProvider>

                                          <ValidationProvider vid="address2" :name="$t('labels.Address line 2')" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="user.address2"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Address line 2')"
                                                required
                                            ></v-text-field>
                                          </ValidationProvider>

                                          <ValidationProvider vid="town" :name="$t('labels.Town')" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="user.town"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Town')"
                                                required
                                            ></v-text-field>
                                          </ValidationProvider>

                                          <ValidationProvider vid="county" :name="$t('labels.County')" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="user.county"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.County')"
                                                required
                                            ></v-text-field>
                                          </ValidationProvider>

                                          <ValidationProvider vid="postcode" :name="$t('labels.Postcode')" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                v-model="user.postcode"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Postcode')"
                                                required
                                            ></v-text-field>
                                          </ValidationProvider>

                                          <ValidationProvider vid="country" :name="$t('labels.Country')" rules="required" v-slot="{ errors }">
                                            <v-select
                                                :items="countriesList"
                                                item-text="name"
                                                item-value="code"
                                                v-model="user.country"
                                                :error-messages="errors[0]"
                                                :label="$t('labels.Country')"
                                                required
                                            ></v-select>
                                          </ValidationProvider>

                                          <h2 class="mt-6 mb-3 heading-5">{{ $t('headings.Organisations') }}</h2>
                                          <ValidationProvider vid="organisations" :name="$t('labels.Organisations')" v-slot="{ errors }">
                                            <v-autocomplete
                                                :items="activeOrganisations"
                                                item-text="name"
                                                item-value="id"
                                                v-model="user.organisation"
                                                :error-messages="errors[0]"
                                                chips
                                                persistent-hint
                                                :hint="$t('hints.Selected organisation can view your name')"
                                            >
                                              <template v-slot:label>
                                                <div>
                                                  {{ $t('labels.Primary Organisation associated with') }} <small>({{ $t("labels.optional") }})</small>
                                                </div>
                                              </template>
                                            </v-autocomplete>
                                          </ValidationProvider>
                                          <v-divider class="mt-12"></v-divider>
                                        </div>

                                        <ValidationProvider vid="preferred_language" :name="$t('labels.Preferred language')" rules="required" v-slot="{ errors }">
                                          <v-select
                                              v-model="user.preferred_language"
                                              :items="languages"
                                              item-text="name"
                                              item-value="code"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Preferred language')"
                                              required
                                          >

                                          </v-select>
                                        </ValidationProvider>

                                        <ValidationProvider vid="password" :name="$t('labels.Confirm password')" rules="required|min:8" v-slot="{ errors }">
                                          <v-text-field
                                              ref="password"
                                              v-model="user.password"
                                              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                              :type="showPassword ? 'text' : 'password'"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Confirm password')"
                                              required
                                              autocapitalize="none"
                                              @click:append="showPassword = !showPassword"
                                          ></v-text-field>
                                        </ValidationProvider>
                                      </ValidationObserver>

                                    </v-form>
                                  </v-card-text>
                                  <v-card-actions class="d-flex justify-space-between">
                                    <v-btn class="pa-2" color="blue darken-1" text @click="accountDialog = false">{{ $t('buttons.Close') }}</v-btn>
                                    <v-btn tile elevation="0" color="primary" @click="handleSubmit">{{ $t('buttons.Submit') }}</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-card-title>

                            <v-card-text v-if="user">
                                <p class="text-body-1">
                                    <span class="font-weight-bold">{{ $t('labels.Name') }}:</span> {{user.name}}<br>
                                    <span class="font-weight-bold">{{ $t('labels.Email') }}:</span> {{user.email}}<br>
                                    <span class="font-weight-bold">{{ $t('labels.Mobile') }}:</span> {{user.mobile}}<br>
                                    <span class="font-weight-bold">{{ $t('labels.Preferred language') }}:</span> {{user.preferred_language_name}}
                                </p>
                                <h3 v-if="user.email1 || user.email2" class="text-body-1 font-weight-bold">{{ $t('headings.Additional notification emails') }}</h3>
                                <p>
                                    {{user.email1}}<br>
                                    {{user.email2}}
                                </p>
                                <h3 v-if="user.address1" class="text-body-1 font-weight-bold">{{ $t('headings.Delivery address') }}</h3>
                                <p class="text-body-1">
                                    <span>{{user.address1}}</span><br>
                                    <span v-if="user.address2">{{user.address2}}<br></span>
                                    {{user.town}}<br>
                                    {{user.county}}<br>
                                    {{user.postcode}}<br>
                                    {{user.country}}<br>
                                </p>
                                <h3 v-if="user.organisations && user.organisations.length > 0" class="text-body-1 font-weight-bold">{{ $t('headings.Organisations') }}</h3>
                                <p class="text-body-1">
                                    <span v-for="organisation in user.organisations" v-bind:key="organisation.id">{{ organisation.name }}<br></span>
                                </p>
                            </v-card-text>
                            <v-sheet
                                    v-else
                                    class="px-3 pt-3 pb-3"
                            >
                                <v-skeleton-loader
                                        class="mx-auto"
                                        type="card"
                                ></v-skeleton-loader>
                            </v-sheet>
                        </v-card>

                        <v-card
                            elevation="0"
                            :color="cardBackground"
                            :dark="isDark"
                            style="border-radius: 10px !important;"
                            class="mx-auto mt-6"
                        >
                          <v-toolbar
                              color="success"
                              dark
                          >
                            <div class="d-flex justify-space-between" style="width: 100%">
                              <div class="text-h6">{{ $t('headings.Member benefits') }}</div>
                              <div>

                              </div>
                            </div>
                          </v-toolbar>

                          <v-card-actions>


                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                color="success"
                                @click="showBenefits = !showBenefits"
                            >
                              {{ $t('buttons.Learn more') }} <v-icon>{{ showBenefits ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </v-card-actions>

                          <v-expand-transition>
                            <div v-show="showBenefits">
                              <v-divider></v-divider>

                              <v-card-text class="black--text">
                                <p class="text-body-1">Coming soon...</p>

                              </v-card-text>

                            </div>
                          </v-expand-transition>
                        </v-card>
                        <v-card
                            elevation="0"
                            :color="cardBackground"
                            :dark="isDark"
                            style="border-radius: 10px !important;"
                            class="mx-auto mt-6"
                        >
                          <v-toolbar
                              color="success"
                              dark
                          >
                            <div class="d-flex justify-space-between" style="width: 100%">
                              <div class="text-h6">{{ $t('headings.Refer friends') }}</div>
                              <div>

                              </div>
                            </div>
                          </v-toolbar>

                          <v-card-actions>


                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                color="success"
                                @click="showReferAFriend = !showReferAFriend"
                            >
                              {{ $t('buttons.Learn more') }} <v-icon>{{ showReferAFriend ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </v-card-actions>

                          <v-expand-transition>
                            <div v-show="showReferAFriend">
                              <v-divider></v-divider>

                              <v-card-text class="black--text">
                                <p class="text-body-1">{{ $t('Share the love and refer friends to receive extra discounts') }}.</p>
                                <p class="text-body-1">{{ $t('You will soon be able to earn up to 100% discount from your subscription renewal, when you refer up to 5 friends') }}.</p>
                                <p class="text-body-1">{{ $t('Your friends will get a 20% discount off their first years subscription') }}.</p>
                                <p class="text-body-1">{{ $t('Watch this space') }}...</p>

                              </v-card-text>

                            </div>
                          </v-expand-transition>
                        </v-card>
                    </v-col>
                    <v-col
                            md="8"
                            sm="12"
                    >
                        <v-dialog v-model="editDialog" max-width="500px">
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ $t('headings.Edit family member / dependant') }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <ValidationObserver ref="observer">
                                                    <v-form v-model="valid" @submit.prevent="handleSubmit">

                                                        <ValidationProvider vid="name" :name="$t('labels.Name')" rules="required" v-slot="{ errors }">
                                                            <v-text-field
                                                                    v-model="editedItem.name"
                                                                    :error-messages="errors[0]"
                                                                    :label="$t('labels.Name')"
                                                                    required
                                                            ></v-text-field>
                                                        </ValidationProvider>

                                                        <ValidationProvider vid="relationship" :name="$t('labels.Relationship')" rules="required" v-slot="{ errors }">
                                                            <v-select
                                                                    :items="getRelationships"
                                                                    v-model="editedItem.relationship"
                                                                    :error-messages="errors[0]"
                                                                    :label="$t('labels.Relationship')"
                                                                    required
                                                            ></v-select>
                                                        </ValidationProvider>

                                                        <ValidationProvider vid="organisation" :name="$t('labels.Organisations')" rules="required" v-slot="{ errors }">
                                                            <v-autocomplete
                                                                    :items="activeOrganisations"
                                                                    item-text="name"
                                                                    item-value="id"
                                                                    v-model="editedItem.organisation"
                                                                    :error-messages="errors[0]"
                                                                    :label="$t('labels.Primary organisation associated with')"
                                                                    required
                                                                    chips
                                                                    persistent-hint
                                                                    :hint="$t('hints.Selected organisation can view family members name')"
                                                            ></v-autocomplete>
                                                        </ValidationProvider>

                                                    </v-form>
                                                </ValidationObserver>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-btn color="blue darken-1" text @click="editDialog = false">{{ $t('buttons.Cancel') }}</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" tile dark elevation="0" @click="save">{{ $t('buttons.Save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <v-dialog
                                v-model="deleteDialog"
                                max-width="290"
                        >
                            <v-card>
                                <v-card-title class="headline">Are you sure?</v-card-title>

                                <v-card-text>
                                  {{ $t('This will delete your dependant, and you will no longer be able to buy tags for them') }}
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <v-btn
                                            color="grey darken-1"
                                            text
                                            @click="deleteDialog = false"
                                    >
                                        {{ $t('buttons.No way') }}
                                    </v-btn>

                                    <v-btn
                                            color="primary"
                                            tile
                                            @click="confirmDeleteItem"
                                    >
                                        {{ $t('buttons.Yes please') }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                          <v-expansion-panels flat focusable v-model="openedPanel">
                            <v-expansion-panel
                                class="mb-4"
                                style="border-radius: 10px !important;border-color: blue"
                            >
                              <v-expansion-panel-header>
                                <div class="d-flex justify-space-between">
                                  <div class="text-body-1 font-weight-bold"><v-icon v-if="stripeSubscription" color="success" class="mr-2">mdi-check-circle</v-icon><v-icon v-else color="red" class="mr-2">mdi-alert</v-icon>{{ $t('headings.Subscription') }}</div>
                                  <v-spacer></v-spacer>
                                  <v-tooltip
                                      left
                                      content-class="info tooltip-left tooltip"
                                      v-model="tooltips[0]"
                                      max-width="300"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-icon v-if="currentTooltip === 0" dark color="primary">info</v-icon>
                                        <span
                                            v-else
                                        ></span>
                                      </span>
                                    </template>
                                    <template v-slot:default>
                                      <v-card flat dark color="info">
                                        <v-card-title class="flex justify-space-between pr-0">
                                          <div>{{ $t('headings.Add Subscription') }}</div>
                                          <v-btn icon @click="endTips"><v-icon>mdi-close</v-icon></v-btn>
                                        </v-card-title>
                                        <v-card-text>
                                          <div v-if="user && user.stripe_subscription" class="text-body-1 text-left">{{ $t('Here is where you can view and manage your subscription') }}.</div>
                                          <div v-else class="text-body-1 text-left">{{ $t('Your first step to get your account up to strength is to subscribe') }}. {{ $t('Your free bundle will then automatically be in your basket ready for you to claim') }}.</div>
                                        </v-card-text>
                                        <v-card-actions v-if="currentTooltip" class="justify-space-between">
                                          <span>{{ currentTooltip }}/{{ tooltips.length }}</span>
                                          <v-btn
                                              v-if="currentTooltip < tooltips.length"
                                              small
                                              elevation="0"
                                              color="success"
                                              @click="nextTip"
                                          >{{ $t('buttons.Next tip') }}</v-btn>
                                          <v-btn
                                              v-else
                                              small
                                              elevation="0"
                                              color="success"
                                              @click="endTips"
                                          >{{ $t('buttons.End tour') }}</v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </template>
                                  </v-tooltip>
                                </div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content class="mt-6">
                                <div v-if="user">
                                  <div v-if="user.stripe_subscription">
                                    <span v-if="user.default_payment_method"><span class="text-subtitle-2">{{ $t('labels.Default payment method') }}:</span> {{ user.default_payment_method.name }}, {{ user.default_payment_method.brand }} **** **** **** {{ user.default_payment_method.last4 }}, Expiry: {{ user.default_payment_method.exp_month }} / {{ user.default_payment_method.exp_year }}<br></span>
                                    <span v-if="user.stripe_subscription.cancel_at === null"><span class="text-subtitle-2">{{ $t('labels.Started at') }}:</span> {{ user.stripe_subscription.current_period_start }}<br></span>
                                    <span><span class="text-subtitle-2">{{ $t('labels.Last payment') }}:</span> {{ user.stripe_subscription.currency === 'eur' ? '€' : '£'}}{{ user.stripe_subscription.latest_invoice.amount_paid }}<br></span>
                                    <span><span class="text-subtitle-2">{{ $t('labels.Next renewal amount') }}:</span> {{ user.stripe_subscription.currency === 'eur' ? '€' : '£'}}{{ user.stripe_subscription.plan.amount }}<br></span>
                                    <span><span class="text-subtitle-2">{{ $t('labels.Next renewal due') }}:</span> {{ user.stripe_subscription.current_period_end }}<br></span>
                                    <span v-if="user.stripe_subscription.cancel_at"><span class="text-subtitle-2">{{ $t('labels.Canceled from') }}:</span> {{ user.stripe_subscription.cancel_at }}<br></span>

                                    <v-dialog
                                        v-if="user.stripe_subscription && user.stripe_subscription.cancel_at === null && user.stripe_subscription.ended_at === null"
                                        v-model="cancelDialog"
                                        width="500"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <div class="d-flex justify-end">
                                          <v-btn
                                              small
                                              elevation="0"
                                              v-bind="attrs"
                                              v-on="on"
                                              class="mt-6"
                                          >
                                            {{ $t('buttons.Cancel future payments') }}
                                          </v-btn>
                                        </div>
                                      </template>

                                      <v-card>
                                        <v-card-title class="headline primary">
                                          {{ $t('headings.Cancel subscription renewal') }}
                                        </v-card-title>

                                        <v-card-text>
                                          <p class="mt-6">{{ $t('This will cancel future recurring payments, after the current subscription ends') }}</p>
                                        </v-card-text>

                                        <v-divider></v-divider>

                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn
                                              color="primary"
                                              text
                                              @click="cancelSubscription"
                                          >
                                            {{ $t('buttons.Confirm') }}
                                          </v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>

                                    <v-dialog
                                        v-if="user.stripe_subscription && user.stripe_subscription.cancel_at === null && user.stripe_subscription.ended_at === null"
                                        v-model="updateDialog"
                                        width="500"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <div class="d-flex justify-end">
                                          <v-btn
                                              small
                                              elevation="0"
                                              v-bind="attrs"
                                              v-on="on"
                                              class="mt-6"
                                          >
                                            {{ $t('buttons.Update card details') }}
                                          </v-btn>
                                        </div>
                                      </template>

                                      <v-card>
                                        <v-card-title class="headline primary">
                                          {{ $t('buttons.Update card details') }}
                                        </v-card-title>

                                        <v-card-text>
                                          <UpdateCard :dialogOpen="updateDialog" v-on:close-update-card="closeUpdateCard"/>
                                        </v-card-text>

                                        <v-divider></v-divider>

                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn
                                              color="primary"
                                              text
                                              @click="updateDialog = false"
                                          >
                                            {{ $t('buttons.Cancel') }}
                                          </v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>



                                  </div>

                                  <span v-if="user.on_trial && !user.stripe_subscription" class="mt-3">{{ $t('After your free trial expires on {date}, you must have an active subscription to purchase new products', { date: user.trial_ends_at }) }}.</span>
                                  <p v-else-if="user.stripe_subscription && user.stripe_subscription.cancel_at" class="mt-3">{{ $t('You must have an active subscription to receive alerts or purchase new products') }}.</p>

                                  <div v-if="user.stripe_subscription === null">
                                    <h1 class="text-h5 primary--text">{{ $t('Get your subscription and claim your FREE bundle') }}</h1>
                                    <h2 class="text-subtitle-1 mt-3 mb-6">{{ $t('You must have an active subscription to receive alerts, purchase new products, or activate tags') }}.</h2>
                                    <p class="body-1 mb-3">{{ $t('For your {subscription} annual subscription you will get:', {subscription: subscriptionPriceWithCurrency}) }}</p>

                                    <div class="d-flex justify-space-between">
                                      <div class="mr-6">
                                        <h3 class="text-subtitle-1 mt-0">{{ $t('A free bundle worth {price}', {price: bundlePrice}) }}</h3>
                                        <ul class="mb-3">
                                          <li>{{ $t('{quantity} iron on labels', {quantity: 25}) }}</li>
                                          <li>{{ $t('{quantity} sticker labels', {quantity: 25}) }}</li>
                                          <li>{{ $t('{quantity} key tags', {quantity: 3}) }}</li>
                                          <li>{{ $t('{quantity} two part bag tag', {quantity: 1}) }}</li>
                                          <li>{{ $t('{quantity} recovery card', {quantity: 1}) }}</li>
                                        </ul>
                                      </div>
                                      <div>
                                        <h3 class="text-subtitle-1 mt-0">{{ $t('headings.Also includes') }}</h3>
                                        <ul class="mb-6">
                                          <li>{{ $t('Unlimited SMS notifications for found items') }}</li>
                                          <li>{{ $t('Refer a friend commission') }}</li>
                                          <li>{{ $t('Free use of our app (android/ios)') }}</li>
                                          <li>{{ $t('Optional partner offers (opt in)') }}</li>
                                        </ul>
                                      </div>


                                    </div>
                                  </div>
                                  <div class="d-flex justify-end">
                                    <v-btn @click="membershipDialog = true" v-if="user.stripe_subscription === null || (user.stripe_subscription && user.stripe_subscription.ended_at)" color="primary"
                                           dark
                                           tile
                                           class="mt-6">{{ $t('buttons.Add subscription') }}</v-btn>
                                  </div>

                                  <div v-if="user.stripe_subscription" class="d-flex justify-end">
                                    <v-btn @click="renewSubscription" v-if="user.stripe_subscription && user.stripe_subscription.cancel_at" color="primary"
                                           dark
                                           tile
                                           class="mt-6">{{ $t('buttons.Renew future payments') }}</v-btn>
                                  </div>
                                </div>
                                <v-sheet
                                    v-else
                                    class="px-3 pt-3 pb-3"
                                >
                                  <v-skeleton-loader
                                      class="mx-auto"
                                      type="card"
                                  ></v-skeleton-loader>
                                </v-sheet>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                class="mb-4"
                                style="border-radius: 10px !important;"
                            >
                            <v-expansion-panel-header>
                              <div class="d-flex justify-space-between">
                                <div class="text-body-1 font-weight-bold"><v-icon v-if="dependants && dependants.length > 0" color="success" class="mr-2">mdi-check-circle</v-icon>{{ $t('headings.Your family members / dependants') }}</div>
                                <v-spacer></v-spacer>
                                  <v-tooltip
                                    left
                                    content-class="info tooltip-left tooltip"
                                    v-model="tooltips[1]"
                                    max-width="400"
                                >
                                  <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-icon v-if="currentTooltip === 0" dark color="primary">info</v-icon>
                                        <span
                                            v-else
                                        ></span>
                                      </span>
                                  </template>
                                  <template v-slot:default>
                                    <v-card flat dark color="info">
                                      <v-card-title class="flex justify-space-between pr-0">
                                        <div>{{ $t('headings.Family members and dependants') }}</div>
                                        <v-btn icon @click="endTips"><v-icon>mdi-close</v-icon></v-btn>
                                      </v-card-title>
                                      <v-card-text>
                                        <div class="text-body-1 text-left">{{ $t('Add your family members of dependants, so that you can purchase tags for them or assign activ8 products') }}.</div>
                                      </v-card-text>
                                      <v-card-actions v-if="currentTooltip" class="justify-space-between">
                                        <span>{{ currentTooltip }}/{{ tooltips.length }}</span>
                                        <v-btn
                                            v-if="currentTooltip < tooltips.length"
                                            small
                                            elevation="0"
                                            color="success"
                                            @click="nextTip"
                                        >{{ $t('buttons.Next tip') }}</v-btn>
                                        <v-btn
                                            v-else
                                            small
                                            elevation="0"
                                            color="success"
                                            @click="endTips"
                                        >{{ $t('buttons.End tour') }}</v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </template>
                                </v-tooltip>
                              </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-6">
                              <v-list v-if="dependants && dependants.length > 0" class="form-card pl-0">
                                <v-list-item
                                    v-for="(dependant, i)  in dependants"
                                    :key="i"
                                    class="pl-0"
                                >
                                  <v-list-item-icon class="mr-3">
                                    <v-icon size="40" color="primary">account_circle</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content class="text-left pl-0">
                                    <v-list-item-title class="text-h6 mb-1">{{dependant.name}}<span v-if="dependant.organisations && dependant.organisations.length > 0" class="text-body-1"> | {{ dependant.organisations[0].name }}</span></v-list-item-title>
                                    <v-list-item-subtitle class="text--primary">{{dependant.relationship}}</v-list-item-subtitle>
<!--                                    <v-list-item-subtitle-->
<!--                                        v-for="(organisation, i) in dependant.organisations"-->
<!--                                        :key="i"-->
<!--                                    >{{organisation.name}}</v-list-item-subtitle>-->

                                    <h4 class="mt-4" v-if="dependantActivatedTags(dependant).length > 0">Active8 {{ $t('headings.tags') }}</h4>
                                    <v-list-item-group
                                        multiple
                                        active-class=""
                                        class="flex"
                                    >
                                      <v-list-item v-for="tag in dependantActivatedTags(dependant)" v-bind:key="tag.id">
                                        <v-list-item-content>
                                          <v-list-item-title>{{ tag.qr_code }}</v-list-item-title>
                                          <v-list-item-subtitle v-if="tag.activated_on">{{ $t("Activated on") }}: {{tag.activated_on}}</v-list-item-subtitle>
                                          <v-list-item-subtitle v-if="tag.product_item">{{ $t("Product item") }}: {{ tag.product_item.name }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                          <div class="d-flex flex-column">
                                            <div class="d-flex align-end">
                                              <div>{{ $t("Public") }}</div>
                                              <v-tooltip max-width="400" bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                  <v-icon
                                                      color="primary"
                                                      dark
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      class="ml-1"
                                                  >
                                                    mdi-information
                                                  </v-icon>
                                                </template>
                                                <span>{{ $t('A public tag will allow any member of the public to scan and return your property') }}. {{ $t('When a public tag is scanned, the finder may contact you by email to arrange the return') }}. {{ $t('Your email address will not be viewable to the finder') }}.</span>
                                              </v-tooltip>
                                            </div>
                                            <v-switch v-model="tag.is_public" @change="updateTag(tag)"></v-switch>
                                          </div>
                                        </v-list-item-action>
                                      </v-list-item>
                                    </v-list-item-group>
                                    <h4 class="mt-4" v-if="dependantPersonalTags(dependant).length > 0">{{ $t('headings.Personal tags') }}</h4>
                                    <v-list-item-group
                                        multiple
                                        active-class=""
                                        class="flex"
                                    >
                                      <v-list-item v-for="tag in dependantPersonalTags(dependant)" v-bind:key="tag.id">
                                        <v-list-item-content>
                                          <v-list-item-title>{{ tag.qr_code }}</v-list-item-title>
                                          <v-list-item-subtitle v-if="tag.activated_on">{{ $t("Activated on") }}: {{tag.activated_on}}</v-list-item-subtitle>
                                          <v-list-item-subtitle v-if="tag.product_item">{{ $t("Product item") }}: {{ tag.product_item.name }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                          <div class="d-flex flex-column">
                                            <div class="d-flex align-end">
                                              <div>{{ $t('Public') }}</div>
                                              <v-tooltip max-width="400" bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                  <v-icon
                                                      color="primary"
                                                      dark
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      class="ml-1"
                                                  >
                                                    mdi-information
                                                  </v-icon>
                                                </template>
                                                <span>{{ $t('A public tag will allow any member of the public to scan and return your property') }}. {{ $t('When a public tag is scanned, the finder may contact you by email to arrange the return') }}. {{ $t('Your email address will not be viewable to the finder') }}.</span>
                                              </v-tooltip>
                                            </div>
                                            <v-switch v-model="tag.is_public" @change="updateTag(tag)"></v-switch>
                                          </div>
                                        </v-list-item-action>
                                      </v-list-item>
                                    </v-list-item-group>

                                  </v-list-item-content>

                                  <v-list-item-action class="align-self-start">
                                    <div>
                                      <v-btn icon @click="editItem(dependant)">
                                        <v-icon color="grey lighten-1">edit</v-icon>
                                      </v-btn>
                                      <v-btn icon @click="deleteItem(dependant)">
                                        <v-icon color="grey lighten-1">delete</v-icon>
                                      </v-btn>
                                    </div>

                                  </v-list-item-action>


                                </v-list-item>
                              </v-list>
                              <p v-else class="text-body-1">{{ $t('You have not added any dependants') }}.</p>

                              <v-dialog v-model="dependantDialog" persistent max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <v-btn color="green" small fab dark v-on="on" class="float-right"><v-icon dark>mdi-plus</v-icon></v-btn>
                                </template>
                                <v-card class="form-card">
                                  <v-card-title>
                                    <span class="headline">{{ $t('headings.Add family member / dependant') }}</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <ValidationObserver ref="observer">
                                      <v-form v-model="valid" @submit.prevent="handleSubmitDependant">

                                        <ValidationProvider vid="name" :name="$t('labels.Name')" rules="required" v-slot="{ errors }">
                                          <v-text-field
                                              v-model="name"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Name')"
                                              required
                                          ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="relationship" :name="$t('labels.Relationship')" rules="required" v-slot="{ errors }">
                                          <v-select
                                              :items="getRelationships"
                                              v-model="relationship"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Relationship')"
                                              required
                                          ></v-select>
                                        </ValidationProvider>

                                        <ValidationProvider vid="organisation" name="$t('labels.Organisations')" rules="required" v-slot="{ errors }">
                                          <v-autocomplete
                                              :items="activeOrganisations"
                                              item-text="name"
                                              item-value="id"
                                              v-model="organisation"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Primary organisation associated with')"
                                              required
                                              chips
                                              persistent-hint
                                              :hint="$t('hints.Selected organisation can view family members name')"
                                          ></v-autocomplete>
                                        </ValidationProvider>

                                        <ValidationProvider v-if="requiresSchool" vid="school" :name="$t('labels.School')" rules="max:128" v-slot="{ errors }">
                                          <v-text-field
                                              v-model="school"
                                              :error-messages="errors[0]"
                                              :label="$t('labels.Your dependents school name, and town')"
                                              :hint="$t('hints.This will help us to get the school registered too')"
                                              persistent-hint
                                          ></v-text-field>
                                        </ValidationProvider>

                                      </v-form>
                                    </ValidationObserver>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-btn color="blue darken-1" text @click="dependantDialog = false">{{ $t('buttons.Cancel') }}</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn class="mx-3" color="primary" tile dark elevation="0" @click="handleSubmitDependant">{{ $t('buttons.Save') }}</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                            <v-expansion-panel class="mb-4" style="border-radius: 10px !important;">
                              <v-expansion-panel-header>
                                <div class="d-flex justify-space-between">
                                  <div class="text-body-1 font-weight-bold"><v-icon color="success" class="mr-2">mdi-check-circle</v-icon>{{ $t('Your Tags') }}</div>
                                  <v-spacer></v-spacer>
                                  <v-tooltip
                                    left
                                    content-class="info tooltip-left tooltip"
                                    v-model="tooltips[2]"
                                    max-width="400"
                                  >
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">
                                        <v-icon v-if="currentTooltip === 0" dark color="primary">info</v-icon>
                                        <span
                                            v-else
                                        ></span>
                                      </span>
                                    </template>
                                    <template v-slot:default>
                                      <v-card flat dark color="info">
                                        <v-card-title class="flex justify-space-between pr-0">
                                          <div>{{ $t('Your tags') }}</div>
                                          <v-btn icon @click="endTips"><v-icon>mdi-close</v-icon></v-btn>
                                        </v-card-title>
                                        <v-card-text>
                                          <div class="text-body-1 text-left">{{ $t('Here is where your active tags will be shown') }}.</div>
                                          <div class="text-body-1 text-left">{{ $t('When you receive your tags, activ8 them by following this button') }}</div>
                                          <div class="text-center pa-3">
                                            <v-img
                                                class="white--text d-inline-block"
                                                style="vertical-align: bottom"
                                                width="80px"
                                                :src="require('@/assets/activ8-logo-alpha.png')"
                                                eager
                                            >
                                            </v-img>
                                          </div>
                                          <div class="text-body-1 text-left">{{ $t('You can decide whether to make each tag public or private by using this switch') }}</div>
                                          <div class="text-center pa-3">
                                            <v-switch class="d-inline-block" v-model="ex11" color="primary" label="public" value="red"></v-switch>
                                          </div>
                                          <div class="text-body-1 text-left">{{ $t('Public means that anyone can scan your tag and return your property') }}. {{ $t('Private means that only your organisation can notify you') }}.</div>
                                        </v-card-text>
                                        <v-card-actions v-if="currentTooltip" class="justify-space-between">
                                          <span>{{ currentTooltip }}/{{ tooltips.length }}</span>
                                          <v-btn
                                              v-if="currentTooltip < tooltips.length"
                                              small
                                              elevation="0"
                                              color="success"
                                              @click="nextTip"
                                          >{{ $t('buttons.Next tip') }}</v-btn>
                                          <v-btn
                                              v-else
                                              small
                                              elevation="0"
                                              color="success"
                                              @click="endTips"
                                          >{{ $t('buttons.End tour') }}</v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </template>
                                  </v-tooltip>
                                </div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content class="mt-6">
                                <div v-if="user">
                                  <v-card-title class="primary--text pb-0">
                                    {{ $t('headings.Your Activ8 tags') }}
                                  </v-card-title>
                                  <v-card-text class="pt-0">
                                    <v-list v-if="user.tags && activatedTags.length > 0" class="form-card">
                                      <v-list-item-group
                                          multiple
                                          active-class=""
                                      >
                                        <v-list-item v-for="tag in activatedTags" v-bind:key="tag.id">
                                          <v-list-item-content>
                                            <v-list-item-title>{{ tag.qr_code }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="tag.activated_on">Activated on: {{tag.activated_on}}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="tag.product_item">Product item: {{ tag.product_item.name }}</v-list-item-subtitle>
                                          </v-list-item-content>
                                          <v-list-item-action>
                                            <div class="d-flex flex-column">
                                              <div class="d-flex align-end">
                                                <div>Public</div>
                                                <v-tooltip max-width="400" bottom>
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        color="primary"
                                                        dark
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="ml-1"
                                                    >
                                                      mdi-information
                                                    </v-icon>
                                                  </template>
                                                  <span>{{ $t('A public tag will allow any member of the public to scan and return your property') }}. {{ $t('When a public tag is scanned, the finder may contact you by email to arrange the return') }}. {{ $t('Your email address will not be viewable to the finder') }}.</span>
                                                </v-tooltip>
                                              </div>
                                              <v-switch v-model="tag.is_public" @change="updateTag(tag)"></v-switch>
                                            </div>
                                          </v-list-item-action>
                                        </v-list-item>
                                      </v-list-item-group>
                                    </v-list>
                                    <p v-else class="text-body-1 pt-2">{{ $t("You don't have any active8 tags") }}. {{ $t("Activate new tags here") }} <router-link
                                        :to="{ name: 'activate' }"
                                        exact
                                    >
                                      <v-img
                                          class="white--text d-inline-block"
                                          style="vertical-align: bottom"
                                          width="80px"
                                          :src="activ8Logo"
                                          eager
                                      >
                                      </v-img>
                                    </router-link></p>
                                  </v-card-text>
                                  <v-card-title class="primary--text pb-0 pt-0">
                                    {{ $t("headings.Your personal tags") }}.
                                  </v-card-title>
                                  <v-card-text>
                                    <v-list v-if="user.tags && personalTags.length > 0" class="form-card">
                                      <v-list-item-group
                                          multiple
                                          active-class=""
                                      >
                                        <v-list-item v-for="tag in personalTags" v-bind:key="tag.id">
                                          <v-list-item-content>
                                            <v-list-item-title>{{ tag.qr_code }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="tag.activated_on">Activated on: {{tag.activated_on}}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="tag.product_item">Product item: {{ tag.product_item.name }}</v-list-item-subtitle>
                                          </v-list-item-content>
                                          <v-list-item-action>
                                            <div class="d-flex flex-column">
                                              <div class="d-flex align-end">
                                                <div>{{ $t('Public') }}</div>
                                                <v-tooltip max-width="400" bottom>
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        color="primary"
                                                        dark
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="ml-1"
                                                    >
                                                      mdi-information
                                                    </v-icon>
                                                  </template>
                                                  <span>{{ $t('A public tag will allow any member of the public to scan and return your property') }}. {{ $t('When a public tag is scanned, the finder may contact you by email to arrange the return') }}. {{ $t('Your email address will not be viewable to the finder') }}.</span>
                                                </v-tooltip>
                                              </div>
                                              <v-switch v-model="tag.is_public" @change="updateTag(tag)"></v-switch>
                                            </div>
                                          </v-list-item-action>
                                        </v-list-item>
                                      </v-list-item-group>
                                    </v-list>
                                    <p v-else class="text-body-1">{{ $t("You don't have any active8 tags") }}.</p>
                                  </v-card-text>
                                </div>
                                <v-sheet
                                    v-else
                                    class="px-3 pt-3 pb-3"
                                >
                                  <v-skeleton-loader
                                      class="mx-auto"
                                      type="card"
                                  ></v-skeleton-loader>
                                </v-sheet>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel style="border-radius: 10px !important;">
                              <v-expansion-panel-header>
                                <div class="d-flex justify-space-between">
                                  <div class="text-body-1 font-weight-bold"><v-icon v-if="user && user.payments && user.payments.length > 0" color="success" class="mr-2">mdi-check-circle</v-icon>{{ $t("Order History") }}</div>
                                  <v-spacer></v-spacer>
                                    <v-tooltip
                                      left
                                      content-class="info tooltip-left tooltip"
                                      v-model="tooltips[3]"
                                      max-width="300"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-icon v-if="currentTooltip === 0" dark color="primary">info</v-icon>
                                        <span
                                            v-else
                                        ></span>
                                      </span>
                                    </template>
                                    <template v-slot:default>
                                      <v-card flat dark color="info">
                                        <v-card-title class="flex justify-space-between pr-0">
                                          <div>{{ $t("Order history") }}</div>
                                          <v-btn icon @click="endTips"><v-icon>mdi-close</v-icon></v-btn>
                                        </v-card-title>
                                        <v-card-text>
                                          <div class="text-body-1 text-left">{{ $t("See your order history, to track current order progress or view past orders") }}.</div>
                                        </v-card-text>
                                        <v-card-actions v-if="currentTooltip" class="justify-space-between">
                                          <span>{{ currentTooltip }}/{{ tooltips.length }}</span>
                                          <v-btn
                                              v-if="currentTooltip < tooltips.length"
                                              small
                                              elevation="0"
                                              color="success"
                                              @click="nextTip"
                                          >{{ $t('buttons.Next tip') }}</v-btn>
                                          <v-btn
                                              v-else
                                              small
                                              elevation="0"
                                              color="success"
                                              @click="endTips"
                                          >{{ $t('buttons.End tour') }}</v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </template>
                                  </v-tooltip>
                                </div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content class="mt-6">
                                <div v-if="user">
                                  <v-list v-if="user.payments && user.payments.length > 0">
                                    <v-list-item>
                                      <v-list-item-content>
                                        <v-list-item v-for="payment in user.payments" v-bind:key="payment.id">
                                          <v-list-item-content>
                                            <v-list-item-title>Order reference: {{ payment.id }}</v-list-item-title>
                                            <v-list-item-subtitle>{{payment.created_at}}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ brand === 'neotag' ? '€' : '£'}}{{payment.amount}}</v-list-item-subtitle>
                                          </v-list-item-content>
                                          <v-list-item-action>
                                            <v-list-item-action-text>{{ payment.status === 'fulfilled' ? 'Order sent' : 'in progress' }}</v-list-item-action-text>
                                          </v-list-item-action>
                                        </v-list-item>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                  <p v-else class="text-body-1">{{ $t('You have not placed any orders') }}</p>
                                </div>
                                <v-sheet
                                    v-else
                                    class="px-3 pt-3 pb-3"
                                >
                                  <v-skeleton-loader
                                      class="mx-auto"
                                      type="card"
                                  ></v-skeleton-loader>
                                </v-sheet>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                    </v-col>
                </v-row>
            </v-container>
            <v-container v-else class="contain-width">
                <v-row>
                    <v-col
                            md="6"
                            sm="12"
                            class="offset-md-3"
                    >
                        <h1 class="text-h2 white--text">{{ $t('headings.Account') }}</h1>
                        <v-card elevation="0" class="form-card">
                            <v-card-title class="primary--text">
                                Registered details
                            </v-card-title>

                            <v-dialog v-model="accountDialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                    <v-btn color="indigo" fab dark absolute top right v-on="on"><v-icon dark>mdi-pencil</v-icon></v-btn>
                                </template>
                                <v-card
                                        class="mx-auto form-card"
                                        outlined
                                >
                                    <v-card-title>
                                        <span class="headline primary--text">{{ $t('headings.Edit registered details') }}</span>
                                    </v-card-title>
                                    <v-card-text class="text--primary">
                                        <v-form v-if="user" v-model="userValid" @submit.prevent="handleSubmit">
                                            <ValidationObserver ref="userObserver">
                                                <ValidationProvider vid="name" :name="$t('labels.Name')" rules="required" v-slot="{ errors }">
                                                    <v-text-field
                                                            v-model="user.name"
                                                            :error-messages="errors[0]"
                                                            :label="$t('labels.Name')"
                                                            required
                                                    ></v-text-field>
                                                </ValidationProvider>
                                                <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required|email" v-slot="{ errors }">
                                                    <v-text-field
                                                            v-model="user.email"
                                                            :error-messages="errors[0]"
                                                            :label="$t('labels.Email')"
                                                            required
                                                    ></v-text-field>
                                                </ValidationProvider>

                                                <div class="d-flex align-start">
                                                  <div style="width: 80px">
                                                    <v-autocomplete
                                                        class="mr-2"
                                                        ref="areaCode"
                                                        v-model="area"
                                                        :items="countryCodes"
                                                        item-text="name"
                                                        item-value="code"
                                                    >
                                                      <template v-slot:selection="data">
                                                        <span class="select-flag"><gb-flag :code="data.item.lang" size="mini" /></span>
                                                      </template>
                                                      <template v-slot:item="{ item }">
                                                        <span class="select-flag"><gb-flag :code="item.lang" size="mini" /><span class="ml-3">{{ item.name }}</span></span>
                                                      </template>
                                                    </v-autocomplete>
                                                  </div>
                                                  <div style="width: 100%">
                                                    <ValidationProvider vid="mobile" :name="$t('labels.Mobile')" :rules="{ required: true, regex: /^[+][0-9]+$/ }" v-slot="{ errors }">
                                                      <v-text-field
                                                          v-model="user.mobile"
                                                          :error-messages="errors[0]"
                                                          :label="$t('labels.Mobile number (digits only)')"
                                                          required
                                                          persistent-hint
                                                          :placeholder="mobilePlaceholder"
                                                          :hint="$t('labels.Required for SMS notifications')"
                                                          @input="updateArea(user.mobile)"
                                                      >
                                                      </v-text-field>
                                                    </ValidationProvider>
                                                  </div>
                                                </div>

                                                <ValidationProvider vid="preferred_language" :name="$t('labels.Preferred language')" rules="required" v-slot="{ errors }">
                                                  <v-select
                                                      v-model="user.preferred_language"
                                                      :items="languages"
                                                      item-text="name"
                                                      item-value="code"
                                                      :error-messages="errors[0]"
                                                      :label="$t('labels.Preferred language')"
                                                      required
                                                  >

                                                  </v-select>
                                                </ValidationProvider>

                                                <ValidationProvider vid="password" :name="$t('labels.Confirm password')" rules="required|min:8" v-slot="{ errors }">
                                                    <v-text-field
                                                            ref="password"
                                                            v-model="user.password"
                                                            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                            :type="showPassword ? 'text' : 'password'"
                                                            :error-messages="errors[0]"
                                                            :label="$t('labels.Confirm password')"
                                                            required
                                                            autocapitalize="none"
                                                            @click:append="showPassword = !showPassword"
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </ValidationObserver>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions class="d-flex justify-center">
                                        <v-btn class="pa-2" color="blue darken-1" text @click="accountDialog = false">{{ $t('buttons.Close') }}</v-btn>
                                        <v-btn tile elevation="0" color="primary" @click="handleSubmit">{{ $t('buttons.Submit') }}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-card-text v-if="user">
                                <p>
                                    <span class="text-subtitle-2">{{ $t('labels.Name') }}:</span> {{user.name}}<br>
                                    <span class="text-subtitle-2">{{ $t('labels.Email') }}:</span> {{user.email}}<br>
                                    <span class="text-subtitle-2">{{ $t('labels.Mobile') }}:</span> {{user.mobile}}<br>
                                    <span class="text-subtitle-2">{{ $t('labels.Preferred language') }}:</span> {{user.preferred_language_name}}
                                </p>
                            </v-card-text>
                            <v-sheet
                                    v-else
                                    class="px-3 pt-3 pb-3"
                            >
                                <v-skeleton-loader
                                        class="mx-auto"
                                        type="card"
                                ></v-skeleton-loader>
                            </v-sheet>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">{{ $t('buttons.Close') }}</v-btn>
        </v-snackbar>
        <v-dialog
                v-model="membershipDialog"
                max-width="600"
        >
            <v-card>
                <v-card-title class="headline primary">
                    {{ $t('headings.Subscription') }}
                </v-card-title>

                <v-card-text>
                    <MembershipForm :locale="$i18n.locale" v-on:close-form="closeForm"/>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="membershipDialog = false"
                    >
                        {{ $t('buttons.Close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <v-dialog
                v-model="trialDialog"
                width="500"
        >
            <v-card>
                <v-card-title class="headline primary">
                    {{ $t('headings.Free trial') }}
                </v-card-title>

                <v-card-text v-if="user">
                    <p class="mt-6 text-body-1">
                      {{ $t("As a loyal user of {brand} we have granted you a years free membership until {date}", {brand: brand, date: user.trial_ends_at}) }}.
                    </p>
                    <p class="text-body-1">
                      {{ $t("You will be able to continue to use our great service, with no interruption, plus the added benefit of free SMS notifications") }}.
                    </p>


                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="trialDialog = false"
                    >
                      {{ $t('buttons.Close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
      <v-menu
          top
          transition="slide-y-transition"
          :offset-y="offset"
      >
        <template v-slot:activator="{ on, attrs }">

          <v-btn
              class="help-menu"
              color="primary"
              dark
              fab
              bottom
              right
              v-bind="attrs"
              v-on="on"
          >
            <v-icon light>
              mdi-help
            </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-title @click="navigate('faqs')">{{ $t('menu.Frequently asked questions') }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title @click="replayTips">{{ $t('Replay tooltip tour') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-dialog
          v-model="welcomeDialog"
          transition="dialog-top-transition"
          max-width="600"
      >
        <v-card class="welcome">
          <v-toolbar
              color="primary"
              dark
          ><div class="text-h4">{{ $t('headings.Welcome') }}</div></v-toolbar>
          <v-card-text>
            <p class="text-h5 pa-12 pb-0">{{ $t("Thank you for subscribing to {brand} and a very warm welcome to our community, the UK's revolutionary lost property solution!", {brand: brandName}) }}<p>
            <p class="text-h5 pa-12 pt-0 pb-0">{{ $t("Press continue to be guided through your dashboard, and the next steps to get you on board") }}.<p>
            <p class="text-h5 pa-12 pt-0 pb-0">{{ $t("If you prefer to speak to a human then you are always welcome to email our team on") }} <a :href="'mailto:' + supportEmail">{{supportEmail}}</a></p>
            <p class="text-h5 pa-12 pt-0 pb-0">{{ $t("Thanks, the {brand} team", {brand: brandName}) }}</p>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
                color="primary"
                elevation="0"
                @click="closeWelcome"
            >{{ $t('buttons.Continue') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
</template>

<script>

    import Footer from './Footer'

    import axios from 'axios';

    import { store } from '../store';
    import {mapActions, mapGetters, mapState} from 'vuex'
    import { userService } from '../services';
    import MembershipForm from './MembershipForm'
    import UpdateCard from './UpdateCard'
    import { i18n } from "../i18n"
    import {extend} from "vee-validate";
    import {regex} from "vee-validate/dist/rules";

    extend('regex', {
      ...regex,
      message: "{_field_} should be numbers only, without spaces"
    });

    export default {
        name: "Account",
        components: {
            'Footer': Footer,
            'MembershipForm': MembershipForm,
            UpdateCard
        },
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Account'),
            htmlAttrs: {
              lang: i18n.locale
            },
          }
        },
        data () {
            return {
                showBenefits: false,
                showReferAFriend: false,
                welcomeDialog: false,
                ex11: ['red', 'indigo', 'orange', 'primary', 'secondary', 'success', 'info', 'warning', 'error', 'red darken-3', 'indigo darken-3', 'orange darken-3'],
                offset: true,
                openedPanel: 0,
                currentTooltip: 0,
                tooltips: [false,false,false,false],
                user: null,
                userEdit: null,
                show: false,
                userValid: false,
                userObserver: '',
                showPassword: false,
                accountDialog: false,
                cancelDialog: false,
                dependantDialog: false,
                membershipDialog: false,
                trialDialog: false,
                snack: false,
                snackColor: '',
                snackText: '',
                name: null,
                relationship: null,
                organisation: null,
                school: null,
                makeTagsPublic: true,
                errorValues: {},
                errorFields: [
                    'name',
                    'relationship'
                ],
                submitted: false,
                valid: false,
                deleteDialog: false,
                deletedItem: {
                    id: ''
                },
                deletedIndex: -1,
                editDialog: false,
                editedIndex: -1,
                editedItem: {
                    name: '',
                    relationship: null,
                    organisations: null,
                    organisation: null
                },
                defaultItem: {
                    name: '',
                    relationship: null,
                    organisations: null,
                    organisation: null
                },
                activeOrganisations: [],
                dependantsList: [],
                loadingDependants: true,
                updateDialog: false,
                organisationId: null,
                area: ''
            }
        },
        mounted () {
            this.$gtag.pageview({
                page_path: '/account'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            if (this.welcomeShown !== true) {
              this.welcomeDialog = true
            }
            else if (this.tooltipsComplete !== true) {
              this.replayTips()
            }

            // userService.getDependants().then(() => {
            //     // we need to 'use' this.dependants to make it reactive
            //     this.dependantsList = this.dependants
            //     this.loadingDependants = false
            // }).catch(error => {
            //     if (error.response && [401, 403, 419].includes(error.response.status)) {
            //         userService.logout().then(() => {
            //             store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
            //         })
            //     }
            // })

            const instance = axios.create({
              baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
              withCredentials: true,
            });

            instance
                .get('/api/users/self')
                .then(response => {
                    this.user = response.data.data
                    this.setSelf(response.data.data)

                    if (this.user.organisations.length > 0) {
                        this.user.organisation = this.user.organisations[0]
                    }

                    if (this.userIsOrganisation === false && (
                            (this.user.existing === false && this.user.stripe_subscription === false) ||
                            (this.user.stripe_subscription && this.user.stripe_subscription.ended_at)
                        ) ||
                        (this.user.existing === true && this.user.on_trial === false)
                    ) {
                        this.membershipDialog = true
                    }

                    if (this.userIsOrganisation === false && this.user.on_trial && (this.user.stripe_subscription === null || (this.user.stripe_subscription && this.user.stripe_subscription.cancel_at))) {
                        this.trialDialog = true
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                })
                .finally(() => this.show = true)

            instance
                .get('/api/organisations/enabled?brand=' + this.brand)
                .then(response => {
                    if (response.status === 200) {
                        let activeOrganisations = response.data.data
                        this.activeOrganisations = activeOrganisations
                        for (let x in activeOrganisations) {
                          if (activeOrganisations[x].slug && activeOrganisations[x].slug === 'rosslyn-park-national-7s-lost-property-system') {
                            this.organisation = activeOrganisations[x]
                            this.organisationId = activeOrganisations[x].id
                          }
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => this.show = true)
        },
        computed: {
            ...mapState({
                dependants: state => state.account.user.dependants,
                stripeSubscription: state => state.account.user.stripe_subscription,
                tooltipsComplete: state => state.account.user.tooltips_complete,
                welcomeShown: state => state.account.user.welcome_shown,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            supportEmail() {
              if (this.brand === 'neotag') {
                return 'info@neotag.es'
              }
              else {
                return 'support@findmykit.com'
              }
            },
            mobilePlaceholder() {
              if (this.brand === 'neotag') {
                return '+34 000 000 000'
              }
              else {
                return '+44 00000 000 000'
              }
            },
            countryCodes() {
              return [
                {
                  name: 'United Kingdom +44',
                  lang: 'gb',
                  code: '+44'
                },
                {
                  name: 'Spain +34',
                  lang: 'es',
                  code: '+34'
                }
              ]
            },
            subscriptionPriceWithCurrency() {
              if (this.brand === 'neotag') {
                return '€' + process.env.VUE_APP_SUBSCRIPTION_EUR
              }

              return '£' + process.env.VUE_APP_SUBSCRIPTION_GBP
            },
            bundlePrice() {
              if (this.brand === 'neotag') {
                return '€' + process.env.VUE_APP_BUNDLE_EUR
              }

              return '£' + process.env.VUE_APP_BUNDLE_GBP
            },
            languages() {
              return [
                {
                  name: i18n.t('messages.English'),
                  code: 'en'
                },
                {
                  name: i18n.t('messages.Spanish'),
                  code: 'es'
                }
              ]
            },
            activ8Logo() {
              if (this.brand === 'neotag') {
                return require('@/assets/activ8-logo-alpha-dark.png')
              }
              return require('@/assets/activ8-logo.png')
            },
            isDark() {
              return Boolean(this.brand === 'neotag')
            },
            cardBackground() {
                if (this.brand === 'neotag') {
                  return '#333'
                }
                return '#E8E8E8'
            },
            getRelationships() {
              return [
                i18n.t('Child I am parent/guardian of'),
                i18n.t('Student'),
                i18n.t('Club member'),
                i18n.t('Team member'),
                i18n.t('Elderly relative'),
                i18n.t('Person I am a carer for'),
                i18n.t('Other')
              ]
            },
            familyComplete() {
              if (this.dependants && this.dependants.length > 0) {
                return true
              }
              return false
            },
            tagsComplete() {
              if (this.user && this.user.tags && (this.activatedTags.length > 0 || this.personalTags.length > 0)) {
                return true
              }
              return false
            },
            strength() {

              let value = 0
              if (this.stripeSubscription) {
                value += 50
              }

              if (this.dependants && this.dependants.length > 0) {
                value += 25
              }

              if (this.user && this.user.tags && ((this.activatedTags && this.activatedTags.length > 0) || (this.personalTags && this.personalTags.length > 0))) {
                value += 25
              }

              return value
            },
            requiresSchool() {
              if (this.organisation === this.organisationId) {
                return true
              }
              else if (this.organisation && this.organisation.slug === 'rosslyn-park-national-7s-lost-property-system') {
                return this.organisation.slug === 'rosslyn-park-national-7s-lost-property-system'
              }
              return false
            },
            userIsOrganisation() {
                return store.getters.userHasRole(['organisation'])
            },
            countriesList () {
              return [
                {name: i18n.t('United Kingdom'), code: 'GB'},
                {name: i18n.t('Singapore'), code: 'SG'},
                {name: i18n.t('Spain'), code: 'ES'},
              ]
            },
            activatedTags: function() {
              return this.user.tags.filter(function(item) {
                return item.activated === true;
              })
            },
            personalTags: function() {
              return this.user.tags.filter(function(item) {
                return item.activated === false;
              })
            },
        },
        methods: {
            ...mapActions('account', ['setSelf', 'updateSelf', 'updateMembership', 'updateSubscription', 'addDependant', 'updateDependant', 'deleteDependant', 'completeTooltips', 'completeWelcome']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            updateArea(mobile) {
                if (mobile.length === 1 && mobile.substring(0, 1) !== '+') {
                  this.user.mobile = '+' + this.user.mobile
                }

                if (mobile.substring(0, 1) === '+' && mobile.length >= 3) {
                  let prefix = mobile.substring(0, 3)

                  let area = this.countryCodes.find( record => record.code === prefix)
                  if (area) {
                    this.area = area.code
                  }
                }
              },
              navigate(routeName) {
                this.$router.push({name: routeName})
              },
              closeWelcome() {
                this.welcomeDialog = false

                this.completeWelcome()
              },
              nextTip(next) {
                this.tooltips = [false,false,false,false]

                let nextPanel = null

                if (this.currentTooltip === 1) {
                  nextPanel = 1
                }
                else if (this.currentTooltip === 2) {
                  nextPanel = 2
                }
                else if (this.currentTooltip === 3) {
                  nextPanel = 3
                }

                setTimeout(() => {
                  if (this.currentTooltip === 1) {
                    this.tooltips = [false,true,false,false]
                    this.currentTooltip = 2
                  }
                  else if (this.currentTooltip === 2) {
                    this.tooltips = [false,false,true,false]
                    this.currentTooltip = 3
                  }
                  else if (this.currentTooltip === 3) {
                    this.tooltips = [false,false,false,true]
                    this.currentTooltip = 4
                  }
                }, 1000)

                this.openedPanel = nextPanel
              },
              endTips() {
                this.tooltips = [false,false,false,false]
                this.openedPanel = null

                this.completeTooltips()

                setTimeout(() => {
                  this.currentTooltip = 0
                }, 5000)
              },
              replayTips() {
                document.getElementById("scrolling-content").scrollTop = 0

                this.currentTooltip = 1
                this.openedPanel = 0
                this.tooltips = [false,false,false,false]
                setTimeout(() => {
                  this.tooltips = [true,false,false,false]
                }, 600)
              },
              dependantActivatedTags(dependent) {
                if (dependent.tags && dependent.tags.length > 0) {
                  return dependent.tags.filter(function(item) {
                    return item.activated === true;
                  })
                }
                return []
              },
              dependantPersonalTags(dependent) {
                if (dependent.tags && dependent.tags.length > 0) {
                  return dependent.tags.filter(function(item) {
                    return item.activated === false;
                  })
                }
                return []
              },
              handleSubmit() {
                  this.$refs.userObserver.validate().then(success => {
                          if (this.userValid) {
                              const { name, email, email1, email2, mobile, password, organisation, address1, address2, town, county, postcode, country, preferred_language } = this.user;
                              let make_tags_public = true

                              if (name && email && password) {

                                  let organisations = [];
                                  if (organisation) {
                                      organisations[0] = organisation
                                  }

                                  this.updateSelf({ name, email, email1, email2, mobile, password, organisations, address1, address2, town, county, postcode, country, make_tags_public, preferred_language }).then(response => {

                                      if (!response) {
                                          // Add the server side errors for each field.
                                          this.$refs.userObserver.setErrors(store.getters.validationErrors);
                                      }
                                      else {
                                          this.user = response
                                          this.userEdit = null
                                          this.user.password = null
                                          this.accountDialog = false
                                      }
                                  })
                              }
                          }
                      }

                  )
              },
              cancelSubscription() {
                  const instance = axios.create({
                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    withCredentials: true,
                  });

                  instance
                      .post('/api/stripe/cancel-subscription')
                      .then(response => {
                          this.user = response.data.data

                          let subscription = response.data.data.stripe_subscription

                          this.updateSubscription(subscription)
                          this.updateMembership(false)

                          this.cancelDialog = false
                          store.dispatch('alert/success', i18n.t('Your membership has been canceled'), { root: true });


                      })
                      .catch(error => {
                          console.log(error)
                          this.cancelDialog = false
                          this.snack = true
                          this.snackColor = 'error'
                          this.snackText = 'Not canceled'

                          if (error.response && [401, 403, 419].includes(error.response.status)) {
                              userService.logout().then(() => {
                                  store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                              })
                          }
                      })
                      .finally(() => this.show = true)
              },
              renewSubscription() {
                  const instance = axios.create({
                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    withCredentials: true,
                  });

                  instance
                      .post('/api/stripe/renew-subscription')
                      .then(response => {
                          this.user = response.data.data

                          let subscription = response.data.data.stripe_subscription

                        this.updateSubscription(subscription)
                        this.updateMembership(true)

                        this.cancelDialog = false
                        store.dispatch('alert/success', i18n.t('Your membership has been renewed'), { root: true });

                      })
                      .catch(error => {
                          console.log(error)
                          if (error.response && [401, 403, 419].includes(error.response.status)) {
                              userService.logout().then(() => {
                                  store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                              })
                          }
                      })
                      .finally(() => this.show = true)
              },
              handleSubmitDependant () {

                let observer = this.$refs.observer;

                observer.validate().then(success => {
                  console.log(success)
                  console.log(this.valid)
                  if (this.valid) {
                    this.submitted = true;
                    const { name, relationship, organisation, makeTagsPublic, school, brand } = this;

                    let organisations = [];
                    if (organisation) {
                      organisations[0] = organisation
                    }

                    if (name, relationship) {

                      this.addDependant({ name, relationship, organisations, makeTagsPublic, school, brand }).then(dependant => {

                        if (!dependant) {
                          // Add the server side errors for each field.
                          observer.setErrors(store.getters.validationErrors);
                        }
                        else {
                          this.dependantDialog = false
                          this.name = null
                          this.school = null
                          this.relationship = null
                          this.organisations = null
                          this.organisation = null
                          this.makeTagsPublic = false
                          // remove errors
                          observer.reset();
                        }


                      })
                    }

                  }
                }).catch(error => {
                  console.log(error)
                  // remove errors
                  observer.reset();
                })
              },
              updateTag(tag) {
                console.log(tag)
                  const instance = axios.create({
                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    withCredentials: true,
                  });

                  instance
                    .patch('/api/tags/' + tag.id, {
                        is_public: tag.is_public
                    })
                    .then(response => {
                      console.log(response.data.data)

                    })
                    .catch(error => {
                      console.log(error)
                      if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                          store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                      }
                    })
                    .finally(() => this.show = true)
              },
              editItem (item) {
                  console.log(item)
                  this.editedIndex = this.dependants.indexOf(item)
                  let organisation = item.organisations[0]
                  item.organisation = item.organisations.length > 0 ? item.organisations[0] : null
                  this.editedItem = Object.assign({}, item)
                  this.editDialog = true
              },

              // deleteItem (item) {
              //     const index = this.dependants.indexOf(item)
              //     confirm('Are you sure you want to delete this item?') && this.dependants.splice(index, 1)
              // },

              close () {
                  console.log("close")
                  this.editDialog = false
                  setTimeout(() => {
                      this.editedItem = Object.assign({}, this.defaultItem)
                      this.editedIndex = -1
                  }, 300)
              },

              save () {

                  if (this.editedIndex > -1) {

                      let localDependants = this.dependants
                      let localEditedIndex = this.editedIndex
                      let localEditedItem = this.editedItem

                      if (localEditedItem.organisation) {
                          localEditedItem.organisations[0] = localEditedItem.organisation
                      }

                      this.updateDependant({ localEditedItem }).then(dependant => {

                          if (!dependant) {
                              // Add the server side errors for each field.
                              this.$refs.observer.setErrors(store.getters.validationErrors);
                          }
                          else {

                              Object.assign(localDependants[localEditedIndex], dependant)

                              this.editDialog = false
                              this.editedItem = {
                                  name: null,
                                  relationship: null,
                                  organisations: null,
                                  organisation: null
                              }
                          }


                      })

                  } else {
                      this.dependants.push(this.editedItem)
                  }
                  this.close()
              },

              deleteItem (item) {
                  this.deletedIndex = this.dependants.indexOf(item)
                  this.deletedItem = Object.assign({}, item)
                  this.deleteDialog = true
              },
              confirmDeleteItem () {

                  this.deleteDialog = false

                  let localDeletedIndex = this.deletedIndex
                  let localDeletedItem = this.deletedItem

                  const instance = axios.create({
                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    withCredentials: true,
                  });

                  instance
                      .delete('/api/dependants/' + localDeletedItem.id)
                      .then(response => {
                          console.log(response.status)
                          if (response.status === 204) {
                              store.dispatch('account/deleteDependant', localDeletedIndex, { root: true });
                              store.dispatch('alert/success', i18n.t('Dependant deleted'), { root: true });
                          }
                      })
                      .catch(error => {
                          console.log(error)
                          if (error.response && [401, 403, 419].includes(error.response.status)) {
                              userService.logout().then(() => {
                                  store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                              })
                          }
                      })
              },
              closeForm() {
                  this.membershipDialog = false
                  this.user.stripe_subscription = this.stripeSubscription
              },
              closeUpdateCard(user) {
                  this.updateDialog = false
                  this.user.default_payment_method = user.default_payment_method
                  store.dispatch('account/updateDefaultPaymentMethod', user.default_payment_method, { root: true });
              }
        },
        watch: {
            welcomeDialog (val) {
              if (val === false) {
                this.replayTips()
              }
            },
            deleteDialog (val) {
                if (val === false) {
                    this.deleteIndex = -1;
                    console.log(this.deleteIndex)
                }
            },
            dependantDialog (val) {
                if (val === false) {
                  this.$refs.observer.reset()
                }
            },
            accountDialog (val) {
              if (val === false) {
                this.$refs.userObserver.reset()
              }
              else {
                this.updateArea(this.user.mobile)
              }
            },
            area(val) {
              if (val !== '') {
                if (this.user.mobile.length === 0) {
                  this.user.mobile = val
                }
                else if (this.user.mobile.substring(0,1) === '+') {
                  this.user.mobile = val + this.user.mobile.substring(3)
                }
                else {
                  this.user.mobile = val + this.user.mobile
                }

                if (this.$refs.areaCode) {
                  this.$refs.areaCode.blur();
                }

              }
            }
        },
    }
</script>

<style scoped>
.tooltip-top::before {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: '';
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
}
.tooltip-top.error::before{
  border-top: solid 8px #ff6060;
}

.tooltip-top.success::before{
  border-top: solid 8px #1B5E20;
}
.tooltip-top.secondary::before{
  border-top: solid 8px #3f3f3f;
}

.tooltip-top.primary::before{
  border-top: solid 8px #246fb3;
}

.tooltip-top.info::before{
  border-top: solid 8px #1B1464;
}


.tooltip-bottom::before{
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: '';
  bottom: 100%;
  left: 50%;
  height: 0;
  width: 0;
}

.tooltip-bottom.error::before{
  border-bottom: solid 8px #ff6060;
}

.tooltip-bottom.success::before{
  border-bottom: solid 8px #1B5E20;
}
.tooltip-bottom.secondary::before{
  border-bottom: solid 8px #3f3f3f;
}

.tooltip-bottom.primary::before{
  border-bottom: solid 8px #246fb3;
}

.tooltip-bottom.info::before{
  border-bottom: solid 8px #1B1464;
}


.tooltip-right::before{
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -8px;
  border-width: 8px;
  border-style: solid;
  border-top: solid 8px transparent;
  border-bottom: solid 8px transparent;
  border-left: solid 8px transparent;
}

.tooltip-right.error::before{
  border-right: solid 8px #ff6060 !important;
}

.tooltip-right.success::before{
  border-right: solid 8px #1B5E20 !important;
}
.tooltip-right.secondary::before{
  border-right: solid 8px #3f3f3f !important;
}

.tooltip-right.primary::before{
  border-right: solid 8px #246fb3 !important;
}

.tooltip-right.info::before{
  border-right: solid 8px #1B1464 !important;
}



.tooltip-left::before{
  content: " ";
  position: absolute;
  top: 50%;
  left: 100%; /* To the left of the tooltip */
  margin-top: -8px;
  border-width: 8px;
  border-style: solid;
  border-top: solid 8px transparent;
  border-bottom: solid 8px transparent;
  border-right: solid 8px transparent;
}

.tooltip-left.error::before{
  border-left: solid 8px #ff6060 !important;
}

.tooltip-left.success::before{
  border-left: solid 8px #1B5E20 !important;
}
.tooltip-left.secondary::before{
  border-left: solid 8px #3f3f3f !important;
}

.tooltip-left.primary::before{
  border-left: solid 8px #246fb3 !important;
}

.tooltip-left.info::before{
  border-left: solid 8px #1B1464 !important;
}

.v-tooltip__content {
  pointer-events: all !important;
}

.help-menu {
  background: transparent;
  position: fixed;
  bottom: 116px;
  right: 16px;
  z-index: 200;
}

.v-list-item__title:hover {
  cursor: pointer
}

.v-tooltip__content {
  opacity: 1 !important;
}

.tooltip {
  border-radius: 10px !important;
}

.welcome {
  border-radius: 10px;
}

.v-expansion-panel-header--active {
  background-color: var(--v-primary-base);
  opacity: 1;
  color: var(--v-textOnPrimary-base);
}
</style>
